import '../css/Photo.css'

const Photo = ({img}) => {
    return (
        <div className='photo' style={{backgroundImage: `url('${img}')`}}></div>
    )
}

export default Photo;